import { Button, Icon } from 'journey-ui'
import React, { useContext } from 'react'
import classNames from 'classnames'
import { CaretDoubleRight, ShoppingCart } from 'phosphor-react'
import { AppContext } from '../../contexts/AppContext'
import { CartItemCount } from './CartItemCount'

export const DesktopFloatBtns = () => {
  const { setCartModalOpen, order, setOrder, cartNotifications } = useContext(AppContext)

  if ((order?.items ?? []).length <= 0) {
    return null
  }

  return (
    <div className="sticky bottom-0 p-2 w-full hidden md:flex justify-center z-40 space-x-2">
      <Button
        className={classNames(
          'space-x-2 items-center flex justify-between bg-gray-100 transition-colors duration-500 p-3 rounded-full overflow-visible',
        )}
        onClick={() => setCartModalOpen(true)}
      >
        <span>Cart</span>
        <div>
          <CartItemCount className="top-1 right-1 pt-0.5" />
          <Icon src={ShoppingCart} />
        </div>
      </Button>
      <Button className="primary" href="/checkout">
        <span>Checkout</span>
        <Icon src={CaretDoubleRight} />
      </Button>
    </div>
  )
}
